var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191308",
    d: "M4.14 14a2.501 2.501 0 0 1 4.715 0h8.476v1.666H8.855a2.501 2.501 0 0 1-4.715 0H.664v-1.667zm5-5.834a2.501 2.501 0 0 1 4.715 0h3.476v1.667h-3.476a2.5 2.5 0 0 1-4.715 0H.664V8.166zm-5-5.833a2.501 2.501 0 0 1 4.715 0h8.476v1.666H8.855A2.501 2.501 0 0 1 4.14 4H.664V2.333zm2.357 1.666a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666m5 5.834a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667m-5 5.833a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
  })));
};
export default SvgFilterIcon;